export const nationality=[
   {
    label:'中國 Chinese',
    value:'中國 Chinese',
   },
   {
    label:'美國 American',
    value:'美國 American',
   },
   {
    label:'澳洲 Australian',
    value:'澳洲 Australian',
   },
   {
    label:'加拿大 Canadian',
    value:'加拿大 Canadian',
   },
   {
    label:'英國 British',
    value:'英國 British',
   },
   {
    label:'菲律賓 Filipino',
    value:'菲律賓 Filipino',
   },
   {
    label:'法國 French',
    value:'法國 French',
   },
   {
    label:'德國 German',
    value:'德國 German',
   },
   {
    label:'印度 Indian',
    value:'印度 Indian',
   },
   {
    label:'印尼 Indonesian',
    value:'印尼 Indonesian',
   },
   {
    label:'日本 Japanese',
    value:'日本 Japanese',
   },
   {
    label:'韓國 Korean',
    value:'韓國 Korean',
   },
   {
    label:'馬來西亞 Malaysian',
    value:'馬來西亞 Malaysian',
   },
   {
    label:'尼泊爾 Nepalese',
    value:'尼泊爾 Nepalese',
   },
   {
    label:'巴基斯坦 Pakistani',
    value:'巴基斯坦 Pakistani',
   },
   {
    label:'新加坡 Singaporian',
    value:'新加坡 Singaporian',
   },
   {
    label:'西班牙 Spanish',
    value:'西班牙 Spanish',
   },
   {
    label:'泰國 Thai',
    value:'泰國 Thai',
   },
   {
    label:'其他 Others',
    value:'其他 Others',
   },
]
export const religion=[
   {
    label:'佛教 Buddhism',
    value:'佛教 Buddhism',
   },
   {
    label:'天主教 Catholicism',
    value:'天主教 Catholicism',
   },
   {
    label:'基督教 Christianity',
    value:'基督教 Christianity',
   },
   {
    label:'猶太教 Judaism',
    value:'猶太教 Judaism',
   },
   {
    label:'穆斯林 Islam',
    value:'穆斯林 Islam',
   },
   {
    label:'沒有宗教 No religion',
    value:'沒有宗教 No religion',
   },
   {
    label:'其他 Others',
    value:'其他 Others',
   },
]
export const placeBirth=[
   {
    label:'中國內地 Mainland China',
    value:'中國內地 Mainland China',
   },
   {
    label:'中國香港 Hong Kong, China',
    value:'中國香港 Hong Kong, China',
   },
   {
    label:'中國澳門 Macao, China',
    value:'中國澳門 Macao, China',
   },
   {
    label:'中國台灣 Taiwan, China',
    value:'中國台灣 Taiwan, China',
   },
   {
    label:'澳洲 Australia',
    value:'澳洲 Australia',
   },
   {
    label:'加拿大 Canada',
    value:'加拿大 Canada',
   },
   {
    label:'法國 France',
    value:'法國 France',
   },
   {
    label:'德國 Germany',
    value:'德國 Germany',
   },
   {
    label:'印度 India',
    value:'印度 India',
   },
   {
    label:'印尼 Indonesia',
    value:'印尼 Indonesia',
   },
   {
    label:'日本 Japan',
    value:'日本 Japan',
   },
   {
    label:'韓國 Korea',
    value:'韓國 Korea',
   },
   {
    label:'馬來西亞 Malaysia',
    value:'馬來西亞 Malaysia',
   },
   {
    label:'尼泊爾 Nepal',
    value:'尼泊爾 Nepal',
   },
   {
    label:'巴基斯坦 Pakistan',
    value:'巴基斯坦 Pakistan',
   },
   {
    label:'新加坡 Singapore',
    value:'新加坡 Singapore',
   },
   {
    label:'西班牙 Spain',
    value:'西班牙 Spain',
   },
   {
    label:'泰國 Thailand',
    value:'泰國 Thailand',
   },
   {
    label:'菲律賓 The Philippines',
    value:'菲律賓 The Philippines',
   },
   {
    label:'英國 United Kingdom',
    value:'英國 United Kingdom',
   },
   {
    label:'美國 USA',
    value:'美國 USA',
   },
   {
    label:'其他 Others',
    value:'其他 Others',
   },
]
export const district=[
    {
     label:'中西區 Central & Western',
     value:'中西區 Central & Western',
    },
    {
     label:'香港東區 Eastern',
     value:'香港東區 Eastern',
    },
    {
     label:'離島區 Islands',
     value:'離島區 Islands',
    },
    {
     label:'九龍城區 Kowloon City',
     value:'九龍城區 Kowloon City',
    },
    {
     label:'葵青區 Kwai Tsing',
     value:'葵青區 Kwai Tsing',
    },
    {
     label:'觀塘區 Kwun Tong',
     value:'觀塘區 Kwun Tong',
    },
   
    {
     label:'南區 Southern',
     value:'南區 Southern',
    },
   
    {
     label:'西貢區 Sai Kung',
     value:'西貢區 Sai Kung',
    },
    {
     label:'沙田區 Sha Tin',
     value:'沙田區 Sha Tin',
    },
    {
     label:'深水埗區 Sham Shui Po',
     value:'深水埗區 Sham Shui Po',
    },
    {
     label:'北區 North',
     value:'北區 North',
    },
    {
     label:'大埔區 Tai Po',
     value:'大埔區 Tai Po',
    },
    {
     label:'荃灣區 Tsuen Wan',
     value:'荃灣區 Tsuen Wan',
    },
    {
     label:'屯門區 Tuen Mun',
     value:'屯門區 Tuen Mun',
    },
    {
     label:'灣仔區 Wan Chai',
     value:'灣仔區 Wan Chai',
    },
    {
     label:'黃大仙區 Wong Tai Sin',
     value:'黃大仙區 Wong Tai Sin',
    },
    {
     label:'油尖旺區 Yau Tsim Mong',
     value:'油尖旺區 Yau Tsim Mong',
    },
    {
     label:'元朗區 Yuen Long',
     value:'元朗區 Yuen Long',
    },
    {
      label:'中國內地 Mainland China',
      value:'中國內地 Mainland China',
   },
   {
      label:'海外 Overseas Country',
      value:'海外 Overseas Country',
   },
]
export const districtEn=[
    {
     label:' Central & Western',
     value:' Central & Western',
    },
    {
     label:' Eastern',
     value:' Eastern',
    },
    {
     label:' Islands',
     value:' Islands',
    },
    {
     label:' Kowloon City',
     value:' Kowloon City',
    },
    {
     label:' Kwai Tsing',
     value:' Kwai Tsing',
    },
    {
     label:' Kwun Tong',
     value:' Kwun Tong',
    },
   
    {
     label:' North',
     value:' North',
    },
   
    {
     label:' Sai Kung',
     value:' Sai Kung',
    },
    {
     label:' Sha Tin',
     value:' Sha Tin',
    },
    {
     label:' Sham Shui Po',
     value:' Sham Shui Po',
    },
    {
     label:' Southern',
     value:' Southern',
    },
    {
     label:' Tai Po',
     value:' Tai Po',
    },
    {
     label:' Tsuen Wan',
     value:' Tsuen Wan',
    },
    {
     label:' Tuen Mun',
     value:' Tuen Mun',
    },
    {
     label:' Wan Chai',
     value:' Wan Chai',
    },
    {
     label:' Wong Tai Sin',
     value:' Wong Tai Sin',
    },
    {
     label:' Yau Tsim Mong',
     value:' Yau Tsim Mong',
    },
    {
     label:' Yuen Long',
     value:' Yuen Long',
    },
    {
      label:' Mainland China',
      value:' Mainland China',
     },
     {
      label:' Overseas Country',
      value:' Overseas Country',
     },
]
export const districtCn=[
    {
     label:'中西區 ',
     value:'中西區 ',
    },
    {
     label:'香港東區 ',
     value:'香港東區 ',
    },
    {
     label:'離島區 ',
     value:'離島區 ',
    },
    {
     label:'九龍城區 ',
     value:'九龍城區 ',
    },
    {
     label:'葵青區 ',
     value:'葵青區 ',
    },
    {
     label:'觀塘區 ',
     value:'觀塘區 ',
    },
   
    {
     label:'香港南區 ',
     value:'香港南區 ',
    },
 
    {
     label:'西貢區 ',
     value:'西貢區 ',
    },
    {
     label:'沙田區 ',
     value:'沙田區 ',
    },
    {
     label:'深水埗區 ',
     value:'深水埗區 ',
    },
    {
     label:'北區 ',
     value:'北區 ',
    },
    {
     label:'大埔區 ',
     value:'大埔區 ',
    },
    {
     label:'荃灣區 ',
     value:'荃灣區 ',
    },
    {
     label:'屯門區 ',
     value:'屯門區 ',
    },
    {
     label:'灣仔區 ',
     value:'灣仔區 ',
    },
    {
     label:'黃大仙區 ',
     value:'黃大仙區 ',
    },
    {
     label:'油尖旺區 ',
     value:'油尖旺區 ',
    },
    {
     label:'元朗區 ',
     value:'元朗區 ',
    },
    {
      label:'中國內地 ',
      value:'中國內地 ',
     },
     {
      label:'海外 ',
      value:'海外 ',
     },
]
export const area=[
    {
     label:'港島 HONG KONG',
     value:'港島 HONG KONG',
    },
    {
     label:'九龍 KOWLOON',
     value:'九龍 KOWLOON',
    },
    {
     label:'新界 NEW TERRITORIES',
     value:'新界 NEW TERRITORIES',
    },
    {
      label:' 海外 Overseas Country',
      value:' 海外 Overseas Country',
     },
]
export const areaCn=[
    {
     label:'港島 ',
     value:'港島 ',
    },
    {
     label:'九龍 ',
     value:'九龍 ',
    },
    {
     label:'新界 ',
     value:'新界 ',
    },
    {
      label:' 海外 ',
      value:' 海外 ',
     },
]
export const areaEn=[
    {
     label:' HONG KONG',
     value:' HONG KONG',
    },
    {
     label:' KOWLOON',
     value:' KOWLOON',
    },
    {
     label:' NEW TERRITORIES',
     value:' NEW TERRITORIES',
    },
    {
      label:' Overseas Country',
      value:' Overseas Country',
     },
]
export const formTo=[
    {
     label:'Admission to FS1 (P1)',
     value:'Admission to FS1 (P1)',
    },
    {
     label:'Interim Admission to FS1 (P1)',
     value:'Interim Admission to FS1 (P1)',
    },
    {
     label:'Interim Admission to FS2 (P2)',
     value:'Interim Admission to FS2 (P2)',
    },
    {
     label:'Interim Admission to DS1(P3-P4)',
     value:'Interim Admission to DS1(P3-P4)',
    },
    {
     label:'Interim Admission to DS2 (P4-P5)',
     value:'Interim Admission to DS2 (P4-P5)',
    },
    {
     label:'Interim Admission to DS3 (P6)',
     value:'Interim Admission to DS3 (P6)',
    },
    {
     label:'DS4(S1) Application',
     value:'DS4(S1) Application',
    },
    {
     label:'DS5(S2) Application',
     value:'DS5(S2) Application',
    },
    {
     label:'MS1(S3) Application',
     value:'MS1(S3) Application',
    },
    {
     label:'MS2(S4) Application',
     value:'MS2(S4) Application',
    },
    {
     label:'MS3(S5)-HKDSE Application',
     value:'MS3(S5)-HKDSE Application',
    },
    {
     label:'MS3(S5)-IBDP Application',
     value:'MS3(S5)-IBDP Application',
    },
]
export const grade=[
    {
     label:'FS1 基階一 ( P1 小一 )',
     value:'FS1 基階一 ( P1 小一 )',
    },
    {
     label:'FS2 基階二（P2小二）',
     value:'FS2 基階二（P2小二）',
    },
    {
     label:'DS1拓階一（P3 小三）',
     value:'DS1拓階一（P3 小三）',
    },
    {
     label:'DS2拓階二（P4 小四）',
     value:'DS2拓階二（P4 小四）',
    },
    {
     label:'DS3拓階三（P5/P6 小五/小六）',
     value:'DS3拓階三（P5/P6 小五/小六）',
    },
    {
     label:'DS4 拓階四 ( S1 中一 )',
     value:'DS4 拓階四 ( S1 中一 )',
    },
    {
     label:'DS5拓階五（S2中二）',
     value:'DS5拓階五（S2中二）',
    },
    {
     label:'MS1通階一（S3中三）',
     value:'MS1通階一（S3中三）',
    },
    {
     label:'MS2 通階二 ( S4中四 )',
     value:'MS2 通階二 ( S4中四 )',
    },
    {
     label:'MS3 通階三 ( S5中五 )',
     value:'MS3 通階三 ( S5中五 )',
    },
    {
     label:'MS3通階三（S5中五） - IBDP',
     value:'MS3通階三（S5中五） - IBDP',
    },
]
export const eventType=[
      {
      label:'FS1',
      value:0,
     },
     {
      label:'FS1(Interim)',
      value:6,
     },
     {
      label:'FS2',
      value:1,
     },
     {
      label:'DS1',
      value:7,
     },
     {
      label:'DS2',
      value:8,
     },
     {
      label:'DS3',
      value:9,
     },
     {
      label:'DS4',
      value:2,
     },
     {
      label:'DS5',
      value:3,
     },
     {
      label:'MS1',
      value:10,
     },
     {
      label:'MS2',
      value:4,
     },
     {
      label:'MS3-HKDSE',
      value:11,
     },
     {
      label:'MS3-IBDP',
      value:5,
     }
]
export const applicationStatus =[
   {
      label:"Open",
      value:0
   },
   {
      label:"Submitted",
      value:1
   },
   {
      label:"Paid",
      value:2
   },
   {
      label:"Pending for amendment",
      value:3
   },
   {
      label:"Re-submitted",
      value:4
   },
   {
      label:"Confirmed",
      value:5
   },
   {
      label:"Interview-1",
      value:6
   },
   {
      label:"Waiting List 1",
      value:7
   },
   {
      label:"Interview-2",
      value:8
   },
   {
      label:"Waiting List 2",
      value:9
   },
   {
      label:"Offered",
      value:10
   },
   {
      label:"No offer",
      value:11
   },
   {
      label:"Offer accepted",
      value:12
   },
   {
      label:"Offer rejected",
      value:13
   },
   {
      label:"Offer expired",
      value:14
   },
]
export const applicationStage =[
   {
      label:"(S0) Not Filling form yet",
      value:0
   },
   {
      label:"(S1) Filling form",
      value:1
   },
   {
      label:"(S3) Finish filling form",
      value:2
   },
   {
      label:"(S5) Finish upload file",
      value:3
   },
   {
      label:"(S6) Need correct the form information",
      value:4
   },
   {
      label:"(S7) Submitted the correction form",
      value:5
   },
   {
      label:"(S8) Form submitted (payment not settle)",
      value:6
   },
   {
      label:"(S9) Form submitted (payment ready)",
      value:7
   },
   {
      label:"(S10) Complete the review information",
      value:8
   },
   {
      label:"(S11) Arranged Interview-1",
      value:9
   },
   {
      label:"(S11A) Waiting List (1st round)",
      value:10
   },
   {
      label:"(S12) Arranged Interview-2",
      value:11
   },
   {
      label:"(S12A) Waiting List (2nd round)",
      value:12
   },
   {
      label:"(S13) Provide Offered",
      value:13
   },
   {
      label:"(S14) No Offered",
      value:14
   },
   {
      label:"(S15) Accepted Offer",
      value:15
   },
   {
      label:"(S16) Rejected Offer",
      value:16
   },
   {
      label:"(S17) No reply",
      value:17
   },
   
]
export const applicationType =[
   {
      label:"FS1(P1)",
      value:0
   },
   {
      label:"Submitted",
      value:1
   },
   {
      label:"FS2 to DS3(P2 to P6)",
      value:2
   },
   {
      label:"DS4(S1)",
      value:3
   },
   {
      label:"DS5(S2)/MS1(S3)",
      value:4
   },
   {
      label:"MS2(S4)/MS3(S5) - HKDSE",
      value:5
   },
   {
      label:"MS3(S5)-IBDP",
      value:6
   },
]
export const operationType =[
   {
      label:"Edit Status",
      value:0
   },
   {
      label:"Confirm Information",
      value:1
   },
   {
      label:"Payment ",
      value:2
   },
   {
      label:"Fill in information",
      value:3
   },
   {
      label:"Confirm Applicant Detail",
      value:4
   },
   {
      label:"Confirm Supporting Document",
      value:5
   },
   {
      label:"Confirm Payment Detail",
      value:6
   },
]
export const ethnicity =[
   '華人 Chinese',
   '孟加拉人 Bangladeshi',
   '菲律賓人 Filipino',
   '印度人 Indian',
   '印尼人 Indonesian',
   '日本人 Japanese',
   '韓國人 Korean',
   '尼泊爾人 Nepalese',
   '巴基斯坦人 Pakistani',
   '斯里蘭卡人 Sri-Lankan',
   '泰國人 Thai',
   '越南人 Vietnamese',
   '其他亞洲人 Other Asian',
   '其他以上沒有分類的種族 Other ethnicities not classified above',
   '沒有資料 Information not available',
]
export const parentLanguage=[
   '廣東話 Cantonese',
   '普通話 Putonghua',
   '英語 English',
   '日語 Japanese',
   '德語 German',
   '法語 French',
   '其他 Others',
]
export const roleName={
   admin:1,
   applicant:2,
   manager:3,
   clerk:4,
}